import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function PuzzleWidget() {
  const { t } = useLanguage();
  const [mobileVisible, setMobileVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const nearBottom = window.innerHeight + window.scrollY >= document.body.scrollHeight - 300;
      setMobileVisible(nearBottom);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Link
      to="/puzzle"
      data-testid="puzzle-widget"
      className={`fixed bottom-14 left-4 sm:left-6 z-[9999] group cursor-pointer transition-opacity duration-300 ${mobileVisible ? 'opacity-100' : 'opacity-0 pointer-events-none sm:opacity-100 sm:pointer-events-auto'}`}
    >
      <div className="relative">
        <div className="absolute inset-0 rounded-2xl bg-brand/30 blur-xl animate-pulse" />
        <div className="relative flex flex-col items-center gap-1">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" className="drop-shadow-[0_0_15px_rgba(227,37,16,0.7)] group-hover:drop-shadow-[0_0_25px_rgba(227,37,16,0.9)] transition-all">
            <path d="M20 8 H28 V12 C28 15.3 30.7 18 34 18 C37.3 18 40 15.3 40 12 V8 H48 C50.2 8 52 9.8 52 12 V20 H48 C44.7 20 42 22.7 42 26 C42 29.3 44.7 32 48 32 H52 V40 C52 42.2 50.2 44 48 44 H40 V48 C40 51.3 37.3 54 34 54 C30.7 54 28 51.3 28 48 V44 H20 C17.8 44 16 42.2 16 40 V32 H20 C23.3 32 26 29.3 26 26 C26 22.7 23.3 20 20 20 H16 V12 C16 9.8 17.8 8 20 8Z" stroke="#E32510" strokeWidth="2.5" fill="none" style={{ filter: 'drop-shadow(0 0 4px rgba(227, 37, 16, 0.8)) drop-shadow(0 0 8px rgba(227, 37, 16, 0.5)) drop-shadow(0 0 16px rgba(227, 37, 16, 0.3))' }} />
            <path d="M20 8 H28 V12 C28 15.3 30.7 18 34 18 C37.3 18 40 15.3 40 12 V8 H48 C50.2 8 52 9.8 52 12 V20 H48 C44.7 20 42 22.7 42 26 C42 29.3 44.7 32 48 32 H52 V40 C52 42.2 50.2 44 48 44 H40 V48 C40 51.3 37.3 54 34 54 C30.7 54 28 51.3 28 48 V44 H20 C17.8 44 16 42.2 16 40 V32 H20 C23.3 32 26 29.3 26 26 C26 22.7 23.3 20 20 20 H16 V12 C16 9.8 17.8 8 20 8Z" stroke="rgba(255, 120, 100, 0.4)" strokeWidth="1" fill="none" />
          </svg>
          <motion.span
            className="font-heading text-[10px] tracking-[0.2em] uppercase font-bold"
            animate={{
              color: ['#E32510', '#ffffff', '#E32510'],
              textShadow: [
                '0 0 8px rgba(227,37,16,0.6), 0 0 16px rgba(227,37,16,0.3)',
                '0 0 8px rgba(255,255,255,0.6), 0 0 16px rgba(255,255,255,0.3)',
                '0 0 8px rgba(227,37,16,0.6), 0 0 16px rgba(227,37,16,0.3)',
              ],
            }}
            transition={{ duration: 2.5, repeat: Infinity, ease: 'easeInOut' }}
          >
            {t('weeklyPuzzle')}
          </motion.span>
        </div>
      </div>
    </Link>
  );
}
